
import { Component, Prop, Vue } from 'vue-property-decorator'
@Component({
    name: 'VdieoComponent'
})
export default class extends Vue {
    @Prop({default: () => {}})readonly editData!: {resSubType: number, resUrl: string}
    get showIframe() {
        return this.editData.resSubType === 23
    }
}
